import { DataLoadError, Loader } from '@creditsights/styleguide-web';
import { Row } from '@tanstack/react-table';
import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { CaseDocumentsQueryFilters } from '../../../../hooks/dockets/useFetchCaseDocuments';
import styles from './AttachmentLoader.module.scss';
import useFetchDocumentAttachments from '../../../../hooks/dockets/useFetchDocumentAttachments';
import { DocketCaseDocument } from '../../../../models/CompanyDockets';

const cx = classNames.bind(styles);

interface DocketAttachmentLoaderProps {
  row: Row<DocketCaseDocument>;
  className?: string;
  page: number;
  pageSize: number;
  filters: CaseDocumentsQueryFilters;
  keyFilings: boolean;
}

const AttachmentLoader = ({
  row,
  className,
  page,
  pageSize,
  filters,
  keyFilings,
}: DocketAttachmentLoaderProps): ReactElement | null => {
  const { isLoading, isError, refetch } = useFetchDocumentAttachments(
    row.original,
    page,
    pageSize,
    filters,
    keyFilings
  );

  if (!isLoading && !isError) {
    return null;
  }

  return (
    <tr className={cx('body', className)} data-testid="attachment-loader-row">
      <td colSpan={row.getVisibleCells().length}>
        {isLoading && <Loader position="center" />}
        {isError && <DataLoadError onRetryClick={refetch} />}
      </td>
    </tr>
  );
};

export default AttachmentLoader;
